// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { designThinkingManifest } from './design-thinking';
import { ideasManifest } from './ideas';
import { solutionsManifest } from './solutions';

/** Група модулів «Ідеї та інновації» (Creative): 3 модулів. */
export const creativeGroup: IModuleGroupManifest = {
  key: 'creative',
  category: 'Creative',
  name: { en: 'Creative', uk: 'Ідеї та інновації' },
  sort: 12,
  modules: [designThinkingManifest, ideasManifest, solutionsManifest],
};
